import React from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { customerSelector } from "./selector";
import { isSignedInSelector } from "ccui-framework";
import PropTypes from "prop-types";

const CustomerName = ({ children }) => {
  const isSignedIn = useSelector((state) => isSignedInSelector(state));
  const { firstname, lastname } = useSelector((state) =>
    customerSelector(state)
  );
  const Container = styled.span`
    font-family: Montserrat, serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.2px;
    color: #1f2021;
  `;

  return isSignedIn ? (
    <Container>
      {firstname} {lastname}
      {children}
    </Container>
  ) : null;
};

CustomerName.propTypes = {
  children: PropTypes.node.isRequired,
};

export { CustomerName };
